"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResolveActivityExpression = void 0;
const value_observer_1 = require("@dqm/value-observer");
const filter_1 = require("@dqm/filter");
class ResolveActivityExpression {
    constructor(producer, context) {
        this.listenerCollection = new value_observer_1.ListenerCollection();
        this.context = context;
        producer.registerValueEventListener((status, error, value) => {
            const transformed = this.resolveActivity(status, error, value);
            this.invokeRegisteredListeners(...transformed);
        });
    }
    registerValueEventListener(listener) {
        return this.listenerCollection.add(listener);
    }
    transformActionActivityExpressions(actionList) {
        const generator = new filter_1.ObjectFilterGenerator();
        const compiler = new filter_1.FilterCompiler(generator);
        const currentContext = this.context || this.makeCurrentContext();
        return actionList.map((action) => {
            if ((0, filter_1.isExpression)(action.active)) {
                const filter = compiler.compile(action.active);
                action.active = filter(currentContext);
            }
            return action;
        });
    }
    makeCurrentContext() {
        const currentDate = new Date();
        const currentTime = currentDate.getHours() + ":" + currentDate.getMinutes();
        const currentDay = currentDate.getDay().toString();
        return {
            currentDay,
            currentTime,
        };
    }
    resolveActivity(status, error, value) {
        if (status !== value_observer_1.ValueStatus.Ok) {
            return [status, error, null];
        }
        if (value === null) {
            return [value_observer_1.ValueStatus.Unavailable, null, null];
        }
        return [
            value_observer_1.ValueStatus.Ok,
            null,
            this.transformActionActivityExpressions(value),
        ];
    }
    invokeRegisteredListeners(status, error, value) {
        this.listenerCollection.invoke(status, error, value);
    }
}
exports.ResolveActivityExpression = ResolveActivityExpression;
//# sourceMappingURL=ResolveActivityExpression.js.map